import { DEFAULT_ROLES } from '@/features/auth/permissions.ts';
import { canUseProjectPermission } from '@/features/auth/project-permission.ts';
import { Permission, type PermissionValue, type ProjectMember, type Role } from '@/features/auth/types.ts';

interface ActionItemsAuthorityInput {
  canAccessAsOrgAdmin?: boolean;
  cloudEnabled: boolean;
  member: ProjectMember | null | undefined;
  roles: Role[];
  user: { isSuperAdmin?: boolean } | null | undefined;
}

interface ActionItemsPermissionInput extends ActionItemsAuthorityInput {
  permission: PermissionValue;
}

export function getActionItemsEffectiveRoles(roles: Role[]): Role[] {
  return roles.length > 0 ? roles : DEFAULT_ROLES;
}

export function canUseActionItemsPermission({
  canAccessAsOrgAdmin = false,
  cloudEnabled,
  member,
  permission,
  roles,
  user,
}: ActionItemsPermissionInput): boolean {
  if (user?.isSuperAdmin === true || canAccessAsOrgAdmin) {
    return true;
  }

  return canUseProjectPermission({
    cloudEnabled,
    member,
    permission,
    roles: getActionItemsEffectiveRoles(roles),
    user,
  });
}

export function canEditActionItems(input: ActionItemsAuthorityInput): boolean {
  return canUseActionItemsPermission({
    ...input,
    permission: Permission.EDIT_ACTION_ITEMS,
  });
}
